import AppSettings from "../../../Settings/AppSettings";
import ServiceWrapper from "../../../Services/ServiceWrapper";
import AuthManager from "../../../Common/AuthManager";
import Utils from "../../../Common/Utils";

let api_base_url = AppSettings.GMS_BACKEND_API_URL;

export const updateProductStatus = async (selectedIds, status, user_id) => {
  const req = {
    product_ids: selectedIds,
    status: status,
    merchant_key: user_id || "",
  };
  let res = await ServiceWrapper.doPost(
    api_base_url + "catalog/products/status",
    req,
    null,
    AuthManager.getGmsToken()
  );
  return res;
};

// Get Catalog products (based on status)
export const getCatalogProduct = async (
  status,
  page = 1,
  searchText = "",
  filteredData = {},
  tags = [],
  user_id
) => {
  try {
    let url = `catalog/products?status=${status}&page=${page}&merchant_key=${user_id}`;
    if (status === "rejected" || status === "under_review") {
      url = `catalog/review_products?status=${status}&page=${page}&merchant_key=${user_id}`;
    }

    if (searchText) {
      url = `${url}&search=${searchText}`;
    }
    if (Object.keys(filteredData).length !== 0 && filteredData.category_id) {
      url = `${url}&category_id=${filteredData.category_id}`;
    }

    if (tags.length > 0) {
      const tagValues = tags.join(",");
      url = `${url}&tags=${tagValues}`;
    }

    let catalogProducts = await ServiceWrapper.doGet(
      api_base_url + url,
      null,
      null,
      AuthManager.getGmsToken()
    );
    return catalogProducts;
  } catch (error) {
    console.log("Error is ", error);
    return false;
  }
};

export const getCatalogCategories = async (user_id) => {
  try {
    let catalogCategories = await ServiceWrapper.doGet(
      api_base_url + `catalog/category?merchant_key=${user_id}`,
      null,
      null,
      AuthManager.getGmsToken()
    );
    return catalogCategories;
  } catch (error) {
    return false;
  }
};
export const getUnmatchedCatalogProducts = async (
  page,
  search,
  catId,
  tags,
  user_id
) => {
  let apiUrl =
    api_base_url + `catalog/products?page=${page}&merchant_key=${user_id}`;
  if (!Utils.isEmpty(search)) {
    apiUrl = apiUrl + `&search=${search}`;
  }
  if (catId && catId !== "all" && typeof catId !== "object") {
    apiUrl = apiUrl + `&category_id=${catId}`;
  }
  if (tags.length > 0) {
    tags = tags.join(",");
    apiUrl = apiUrl + `&tags=${tags}`;
  }
  let catalogProducts = await ServiceWrapper.doGet(
    apiUrl,
    null,
    null,
    AuthManager.getGmsToken()
  );
  return catalogProducts;
};

export const getManualMatchedCatalogProducts = async (
  page,
  search,
  user_id
) => {
  let apiUrl =
    api_base_url + `catalog/manual_matched_products?page=${page}&merchant_key=${user_id}`;
  if (!Utils.isEmpty(search)) {
    apiUrl = apiUrl + `&search=${search}`;
  }

  let catalogProducts = await ServiceWrapper.doGet(
    apiUrl,
    null,
    null,
    AuthManager.getGmsToken()
  );
  return catalogProducts;
};

export const getUnmatchedGMSAllProducts = async (
  industryId,
  pageNo,
  searchText,
  categoryId,
  attributes,
  user_id
) => {
  try {
    let reqUrl =
      api_base_url +
      `catalog/${industryId}/gms-products?page=${pageNo}&merchant_key=${user_id}`;
    if (!Utils.isEmpty(searchText)) {
      reqUrl = reqUrl + `&search=${searchText}`;
    }
    if (!Utils.isEmpty(categoryId)) {
      reqUrl = reqUrl + `&category_id=${categoryId}`;
    }

    if (!Utils.isEmpty(attributes)) {
      reqUrl = reqUrl + `&attr=${attributes}`;
    }

    let response = await ServiceWrapper.doGet(
      reqUrl,
      null,
      null,
      AuthManager.getGmsToken()
    );
    return response;
  } catch (error) {
    return false;
  }
};

export const ignoreUnmatchedProducts = async (product_ids, user_id) => {
  try {
    const req = {
      product_ids,
      status: "ignored",
      merchant_key: user_id || "",
    };
    if (req.product_ids.length > 0) {
      let res = await ServiceWrapper.doPost(
        api_base_url + "/catalog/products/status",
        req,
        null,
        AuthManager.getGmsToken()
      );
      return res;
    }
  } catch (error) {
    console.log("Some error occurs while ignoring products");
  }
};

export const getSuggestedGmsProducts = async (
  pageNo,
  searchText,
  categoryId,
  cat_prod_id,
  user_id
) => {
  try {
    // let reqUrl = api_base_url + `catalog/gms-products/suggested?page=${pageNo}`;
    let reqUrl =
      api_base_url +
      `catalog/gms-products/suggested?page=${pageNo}&catalog_product_id=${cat_prod_id}&merchant_key=${user_id}`;
    if (!Utils.isEmpty(searchText)) {
      reqUrl = reqUrl + `&search=${searchText}`;
    }
    if (!Utils.isEmpty(categoryId)) {
      reqUrl = reqUrl + `&category=${categoryId}`;
    }
    let response = await ServiceWrapper.doGet(
      reqUrl,
      null,
      null,
      AuthManager.getGmsToken()
    );
    return response;
  } catch (error) {
    console.log("Error while getting suggest list", error);
    return false;
  }
};

export const manualMatchProduct = async (
  gms_product_id,
  catalog_product_uid
) => {
  try {
    const req = {
      gms_product_id,
      uid: catalog_product_uid,
    };
    let res = await ServiceWrapper.doPut(
      api_base_url + "catalog/products/manual_match",
      req,
      null,
      AuthManager.getGmsToken()
    );

    return res;
  } catch (error) {
    console.log("Some error occurs while manual matching products", error);
    return false;
  }
};

export const getGMSCategory = async (industryId) => {
  if (!industryId) return;
  try {
    let res = await ServiceWrapper.doGet(
      api_base_url + `industry/${industryId}/categorytype/category`,
      null,
      null,
      AuthManager.getGmsToken()
    );
    return res;
  } catch (error) {
    console.log("Error while fetch dashboard data");
    return {};
  }
};

export const getCategoryList = async (industryId) => {
  try {
    const res = await ServiceWrapper.doGet(
      `${api_base_url}industry/${industryId}/category`,
      null,
      null,
      AuthManager.getGmsToken()
    );
    return res.errorfound ? [] : res.data.data;
  } catch (error) {
    console.error(error);
    return [];
  }
};

export const exportCatalog = async (merchantId) => {
  try {

    const res = await ServiceWrapper.doPost(
      `${api_base_url}catalog/export_products/${merchantId}`,
      {},
      null,
      AuthManager.getGmsToken()
    );

    return res;
  } catch (error) {
    console.error(error);
    return null;
  }
}

export const downloadCatalogData = async (jobId) => {
  try {
    let res = await ServiceWrapper.doGet(
      `${api_base_url}job/status/${jobId}`,
      null,
      null,
      AuthManager.getGmsToken()
    );
    return res;
  } catch (error) {
    console.log(error);
    return null;
  }
}

export const addToCategory = async (productIds, categoryId) => {
  const request = {
    product_ids: productIds,
    category: categoryId,
  };
  let res = await ServiceWrapper.doPost(
    api_base_url + "/catalog/products/req",
    request,
    null,
    AuthManager.getGmsToken()
  );
  return res;
};

// Get dashboard count
export const getDashboardCount = async (merchant_key) => {
  try {
    const url = `catalog/dashboard?merchant_key=${merchant_key}`;
    let res = await ServiceWrapper.doGet(
      api_base_url + url,
      null,
      null,
      AuthManager.getGmsToken()
    );
    return res;
  } catch (err) {
    console.log("Error while ");
    return false;
  }
};

export const getMatchedOrApprovedProducts = async (
  industryId,
  status,
  page,
  searchText,
  filterType,
  category,
  gmsAttribute,
  tags = [],
  user_id
) => {
  let url = `catalog/match_products?industry_id=${industryId}&status=${status}&filter_type=${filterType}&merchant_key=${user_id}`;
  if (page > 1) {
    url = url + `&page=${page}`;
  }
  if (!Utils.isEmpty(searchText)) {
    url = url + `&search=${searchText}`;
  }
  if (!Utils.isEmpty(category) && category !== "all") {
    url = url + `&category_id=${category}`;
  }
  if (!Utils.isEmpty(gmsAttribute)) {
    url = url + `&attr=${gmsAttribute}`;
  }
  if (tags.length > 0) {
    url = url + `&tags=${tags}`;
  }
  let catalogProducts = await ServiceWrapper.doGet(
    api_base_url + url,
    null,
    null,
    AuthManager.getGmsToken()
  );
  return catalogProducts;
};

// Approve all matched products
export const approveProducts = async (user_id) => {
  try {
    const req = { merchant_key: user_id };
    let res = await ServiceWrapper.doPut(
      api_base_url + "catalog/products/approve",
      req,
      null,
      AuthManager.getGmsToken()
    );
    return res;
  } catch (error) {
    console.log("Some error occurs while manual matching products", error);
    return false;
  }
};

export const ignoreRejectedProducts = async (product_ids, user_id) => {
  try {
    const req = {
      product_ids,
      merchant_key: user_id || "",
    };
    if (req.product_ids.length > 0) {
      let res = await ServiceWrapper.doPost(
        api_base_url + "/catalog/products/ignore",
        req,
        null,
        AuthManager.getGmsToken()
      );
      return res;
    }
  } catch (error) {
    console.log("Some error occurs while ignoring products");
  }
};

export const getMatchedProduct = async (gms_product_id) => {
  try {
    const url = `catalog/matched-gms-products?gms_product_id=${gms_product_id}`;
    let res = await ServiceWrapper.doGet(
      api_base_url + url,
      null,
      null,
      AuthManager.getGmsToken()
    );
    return res;
  } catch (err) {
    console.log("Error while ");
    return false;
  }
};

export const unmatchProduct = async (catalog_product_id) => {
  try {
    let res = await ServiceWrapper.doPut(
      api_base_url +
      `catalog/products/unmatch_manually?catalog_product_id=${catalog_product_id}`,
      null,
      null,
      AuthManager.getGmsToken()
    );
    return res;
  } catch (error) {
    return false;
  }
};

export const getCatalogLogs = async (user_id) => {
  try {
    let catalogLog = await ServiceWrapper.doGet(
      api_base_url + `catalog/logs?merchant_key=${user_id}`,
      null,
      null,
      AuthManager.getGmsToken()
    );
    return catalogLog;
  } catch (error) {
    return false;
  }
};

export const getMarchant = async (id) => {
  try {
    let merchants = await ServiceWrapper.doGet(
      api_base_url + `catalog/merchants`,
      null,
      null,
      AuthManager.getGmsToken()
    );
    return merchants;
  } catch (error) {
    return false;
  }
};

export const rejectCatalogProducts = async (productInfo) => {
  try {
    const response = await ServiceWrapper.doPut(
      `${api_base_url}catalog/reject-products`,
      productInfo,
      null,
      AuthManager.getGmsToken()
    );
    return response;
  } catch (error) {
    console.log(error);
    return null;
  }
};

export const createCatelogProducts = async (productInfo) => {
  try {
    const response = await ServiceWrapper.doPost(
      `${api_base_url}catalog/bulk_create_products`,
      productInfo,
      null,
      AuthManager.getGmsToken()
    );
    return response;
  } catch (error) {
    console.log(error);
    return null;
  }
};

export const changeCategories = async (categoryInfo) => {
  try {
    const response = await ServiceWrapper.doPut(
      `${api_base_url}catalog/change-category`,
      categoryInfo,
      null,
      AuthManager.getGmsToken()
    );
    return response;
  } catch (error) {
    console.log(error);
    return null;
  }
};

export const multipleCategoryChange = async (categoryInfo) => {
  try {
    const response = await ServiceWrapper.doPut(
      `${api_base_url}catalog/change-multiple-category`,
      categoryInfo,
      null,
      AuthManager.getGmsToken()
    );
    return response;
  } catch (error) {
    console.log(error);
    return null;
  }
};
